<template>
    <ul class="drilldown_menu" :class="[classes]" @click.stop>
        <slot></slot>
        <li
            v-for="(item, index) in dataTree"
            :key="index"
            class="drilldown_item"
        >
            <template v-if="item.subnav && item.subnav.length > 0">
                <a
                    :ref="el => { drilldownParent[index] = el }"
                    @click="showNestedDropdown(index), submenuClick()"
                    class=""
                    @click.prevent
                    href="#"
                    :data-id="index"
                >
                    <div class="drilldown_text">
                        <fa v-if="item.icon" :icon="['fal', item.icon]"></fa>
                        <p>{{ item.title }}</p>
                        <fa class="ml-auto" :icon="['fal', 'angle-right']"></fa>
                    </div>
                </a>
            </template>
            <template v-else>
                <router-link class="" to="/" :data-id="index">
                    <div class="drilldown_text">
                        <fa v-if="item.icon" :icon="['fal', item.icon]"></fa>
                        <p>{{ item.title }}</p>
                    </div>
                    <div class="multi_drilldown__child" v-if="item.child">
                        <p v-for="(child, index) in item.child" :key="index">
                            <fa
                                v-if="child.icon"
                                :icon="['fal', child.icon]"
                            ></fa>
                            {{ child.title }}
                        </p>
                    </div>
                </router-link>
            </template>
            <DrillDownList
                v-if="item.subnav && item.subnav.length > 0"
                :dataTree="item.subnav"
                classes="drilldown_submenu"
            >
                <li class="drilldown_back" :ref="el => { back[index] = el }" @click="getBack(index)">
                    <fa :icon="['fal', 'angle-left']"></fa>
                    Back
                </li>
            </DrillDownList>
        </li>
    </ul>
</template>

<script>
import { ref } from '@vue/reactivity';
import { onBeforeUpdate } from '@vue/runtime-core';
export default {
    name: 'DrillDownList',
    props: {
        dataTree: {
            type: Array,
            required: false,
        },
        showPopper: {
            type: Boolean,
            default: false,
        },
        isActive: {
            type: Boolean,
            default: false,
        },
        classes: {
            type: String,
            default: '',
        },
    },
    setup(props, context) {
        const drilldownParent = ref([]);
        const back = ref([]);
        const submenuClick = () => {
            context.emit('submenuClick');
        }
        const showNestedDropdown = (index) => {
            console.log(drilldownParent.value);
            drilldownParent.value[index].closest('.drilldown_menu').classList.add('invisible');
            drilldownParent.value[index].nextElementSibling.classList.add('active', 'visible');
            let parent = drilldownParent.value[index].closest('.drilldown');
            let height = drilldownParent.value[index].nextElementSibling.offsetHeight;
            parent.style.height = height + 'px';
        };
        const getBack = (index) => {
            back.value[index].parentNode.classList.remove('active', 'visible');
            back.value[index].parentNode.closest('.drilldown_menu.invisible').classList.remove('invisible');
            let parent = document.querySelector('.drilldown');
            let height = back.value[index].closest('.active').offsetHeight;
            parent.style.height = height + 'px';
        }
        onBeforeUpdate(() => {
            drilldownParent.value = [];
            back.value = ref([]);
        })
        return {
            drilldownParent,
            showNestedDropdown,
            getBack,
            back,
            submenuClick,
        };
    },
};
</script>

<style scoped>
.drilldown_menu {
    @apply flex flex-nowrap flex-col bg-white dark:bg-dark-100 px-4 shadow-dropdown dark:shadow-dropdownDark fixed bottom-0 left-0 right-0 z-50;
}
.drilldown_menu.close {
    visibility: hidden;
    box-shadow: none;
}
.drilldown_submenu {
    @apply absolute block bottom-0 left-full w-full -z-[1] shadow-dropdown dark:shadow-dropdownDark;
    transition: transform 0.15s ease;
}
.drilldown_submenu.active {
    @apply z-10 block -translate-x-full;
}
.drilldown_menu li a {
    @apply flex flex-col w-full py-6;
}
.drilldown_menu li a svg {
    @apply text-sm text-gray-500;
}
.drilldown_menu li:not(:last-of-type) {
    @apply border-b border-gray-200 dark:border-black-900;
}
.drilldown_menu li:last-of-type {
    @apply border-b-0;
}
.drilldown_menu li a .drilldown_text {
    @apply mr-auto flex w-full items-center text-sm text-dark-200 dark:text-white;
}
.drilldown_menu li a .drilldown_text svg {
    @apply text-xl text-gray-300 mr-2 dark:text-white;
}
.drilldown_back {
    @apply cursor-pointer py-6 border-b border-gray-200 dark:border-black-900 text-dark-200 dark:text-white text-sm;
}
.drilldown_back svg {
    @apply mr-1 text-gray-500 dark:text-white;
}
.multi_drilldown__child {
    @apply ml-[1.3125rem] mt-6;
}
.multi_drilldown__child p {
    @apply pb-6 text-sm text-dark-200 dark:text-white;
}
.multi_drilldown__child svg {
    @apply text-xl text-gray-300 mr-2 dark:text-white;
}
</style>
